import { z } from "zod";
import { createListBoxSchema } from "./common";

export const profileSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  phoneNumber: z
    .string()
    .regex(
      /^\+65\s?[0-9]{8}$/,
      "Please enter a valid phone number (e.g. +65 90010101)",
    ),
  company: z.string().min(1, "Company name is required"),
  industry: createListBoxSchema<string>(),
  role: createListBoxSchema<string>(),
});

export type ProfileFormData = z.infer<typeof profileSchema>;
